import { useContext } from "react";

export const useContextHandler = (ContextProvider, name, validate = false) => {
  const context = useContext(ContextProvider)
  if (context === undefined && validate) {
    console.warn(`${name} must be used within a ${name}.Provider`)
  }
  return context
} 